var _defs, _mask, _use, _use2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "14.458%",
    x2: "100%",
    y2: "85.542%",
    id: "vue_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.5,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "vue_svg__a",
    d: "M37.687.409H.715l48.154 80.323L95.984.409H59.73L48.87 18.945z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 11)",
    fill: "none",
    fillRule: "evenodd"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "vue_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vue_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#50B883",
    xlinkHref: "#vue_svg__a"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.24,
    fill: "url(#vue_svg__b)",
    xlinkHref: "#vue_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.3,
    fill: "#475365",
    style: {
      mixBlendMode: "multiply"
    },
    mask: "url(#vue_svg__c)",
    d: "M19.813.409L48.66 49.277 77.388.409z"
  })));
}
export default "data:image/svg+xml;base64,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";
export { SvgVue as ReactComponent };